export enum EIPOButtons {
  NOTIFY_ME = "NOTIFY_ME",
  START_BUY = "START_BUY",
  BUY_PENDING = "BUY_PENDING",
  DISPLAY_PORTFO = "DISPLAY_PORTFO",
  DISPLAY_ORDER_RECEIPT = "DISPLAY_ORDER_RECEIPT",
  REMOVE_BUY_ORDER = "REMOVE_BUY_ORDER",
}
